import { Offer } from "../model/Offer";
import OffersDao from "../infrastructure/dao/OffersDao";
import { NumberishId } from "../model/type";

const getOffer = (dao: OffersDao): GetOffer => offerId => {
    return dao.find(offerId);
}
export default getOffer;

export type GetOffer = (offerId: NumberishId) => Promise<Offer>;
